import { BaseRouteService } from 'core/services';

class AddressCompletionRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'address-completion/';
	}

	find(address) {
		return super.create(this.base + 'search', address);
	}

	verify(address) {
		return super.create(this.base + 'verify', address);
	}
}

export default AddressCompletionRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/AddressCompletionRouteService.js